<div *ngIf="isVisible" @fadeInOut class="cookie-banner-container">
    <div class="cookie-banner-content">
        <div class="cookie-info">
            <div class="cookie-text">
                <p>
                    <strong>Cookie Preferences:</strong>
                    We use cookies to enhance your experience.
                    Read our <a routerLink="/cookie-policy">Cookie Policy</a>.
                </p>
            </div>
        </div>
        <div class="cookie-actions">
            <button class="btn-decline" (click)="onDecline()">Only Necessary</button>
            <button class="btn-accept" (click)="onAccept()">Accept</button>
        </div>
    </div>
</div>